export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Mechanics',
        category: 'Game',
        description: 'Gameplay mechanisms or rules used in the game.',
        summarise: {
            prefix: 'Mechanic'
        },
        unit: 'mechanic'
    },
    rules: {
        linked: [],
        legacy: ['mechanics']
    }
}